module.exports = __webpack_public_path__ + "img/Checkmark-lightblue.3d4131df.svg";